module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading || _vm.editAnnouncementUpdating
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('page-title', {
    attrs: {
      "title": "Editar Anúncio",
      "moduleIdentifier": "mercadoLivre"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.product.status
  }, [_vm._v(_vm._s(_vm.$t(((_vm.product.status) + ".label"))))]), _vm._v(" "), (_vm.canShowStatusAction) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "title": _vm.statusActionText
    },
    on: {
      "click": _vm.changeStatus
    }
  }, [_c('i', {
    class: _vm.statusActionIcon
  })]) : _vm._e()])]), _vm._v(" "), (_vm.product && _vm.sourceProduct) ? _c('div', [_c('marketplace-announcement-edit-product', {
    ref: "marketplaceProvideProduct",
    attrs: {
      "sourceProduct": _vm.sourceProduct,
      "product": _vm.product
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('save.label')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--success",
    on: {
      "click": _vm.savePrice
    }
  }, [_vm._v(_vm._s(_vm.$t('save.price.label')))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf461362","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MarketplaceAnnouncement/Edit.vue
// module id = 3436
// module chunks = 0